import { IconType, SvgIcon } from './SvgIcon';

export const CircleFilledCheckIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 20 20">
    <path
      d="M10.0013 1.66797C5.41797 1.66797 1.66797 5.41797 1.66797 10.0013C1.66797 14.5846 5.41797 18.3346 10.0013 18.3346C14.5846 18.3346 18.3346 14.5846 18.3346 10.0013C18.3346 5.41797 14.5846 1.66797 10.0013 1.66797ZM13.5013 8.58464L9.5013 12.5846C9.16797 12.918 8.66797 12.918 8.33464 12.5846L6.5013 10.7513C6.16797 10.418 6.16797 9.91797 6.5013 9.58464C6.83464 9.2513 7.33464 9.2513 7.66797 9.58464L8.91797 10.8346L12.3346 7.41797C12.668 7.08464 13.168 7.08464 13.5013 7.41797C13.8346 7.7513 13.8346 8.2513 13.5013 8.58464Z"
      fill="currentColor"
    />
  </SvgIcon>
);

CircleFilledCheckIcon.displayName = 'CircleCheckIcon';
